module.exports = __webpack_public_path__ + "static/dance_1024-e7ccbf04d562ca9b6354ed3f03896f1b.mp4";